import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import CitiesPage from "./pages/CitiesPage";
import CityDetailPage from "./pages/CityDetailPage";
import DepartmentPage from "./pages/DepartmentPage";
import PartnerBadgePage from "./pages/PartnerBadgePage";
import SimulatorPage from "./pages/SimulatorPage";
import PartnerPage from "./pages/PartnerPage";
import QuotePage from "./pages/QuotePage";
import AboutPage from "./pages/AboutPage";
import { PrivacyPage } from "./pages/LegalPages";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./lib/auth";

function LegacyCityRedirect() {
  const { city } = useParams();
  return <Navigate to={`/villes/${city}`} replace />;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/villes" element={<CitiesPage />} />
              <Route path="/villes/:slug" element={<CityDetailPage />} />
              <Route path="/departements/:slug" element={<DepartmentPage />} />
              <Route path="/simulateur" element={<SimulatorPage />} />
              <Route path="/devis" element={<QuotePage />} />
              <Route path="/qui-sommes-nous" element={<AboutPage />} />
              <Route path="/politique-de-confidentialite" element={<PrivacyPage />} />
              <Route path="/devenir-partenaire" element={<PartnerPage />} />
              <Route path="/badge-partenaire" element={<PartnerBadgePage />} />
              <Route path="/partenaires" element={<Navigate to="/devis" replace />} />
              <Route path="/conciergerie" element={<Navigate to="/devis" replace />} />
              <Route path="/conciergerie/:city" element={<LegacyCityRedirect />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboardPage />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
